<template>
  <div
    class="grid grid-cols-1 tablet:grid-cols-2 gap-x-16 laptop:gap-x-56 gap-y-4"
  >
    <template
      v-for="({ key, ...table }, index) in props.tables"
      :key="key || index"
    >
      <!-- suppress RequiredAttributes -->
      <StatTable
        v-bind="table"
        class="mb-auto"
      />
    </template>
  </div>
</template>

<script setup lang="ts">
import type { Image } from '~/utils/types'

interface Stat {
  key?: string
  label: string
  value?: string | number
  default?: string
  description?: string
}

const props = defineProps<{
  tables: {
    key?: string
    // table data
    stats: Stat[]
    background: Image
    title: string
  }[]
}>()
</script>
